module.exports = __webpack_public_path__ + "static/img/ghs.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/ghs.png
// module id = vbTm
// module chunks = 9